import { SERVICE_STARTPAGE, Services } from '~/constants';
import { PROMPT_MIN_WORDS_LIMIT, PROMPT_MAX_LENGTH_LIMIT } from './constants';

/**
 *
 */
const hasMinWords = (prompt: string | null): boolean => {
  return !!prompt && prompt.split(' ').length >= PROMPT_MIN_WORDS_LIMIT;
};

/**
 *
 */
const hasRightLength = (prompt: string | null): boolean => {
  return !!prompt && prompt.length <= PROMPT_MAX_LENGTH_LIMIT;
};

/**
 *
 */
const getButtonClassNames = ({
  tokensLeft,
}: {
  tokensLeft: number;
}): string[] => {
  const className = tokensLeft === 0 ? 'ai-tokens-none' : 'ai-tokens-available';
  return [className];
};

/**
 *
 */
const getRequirementsMessage = (highlighted: boolean) => {
  return `${
    highlighted ? 'Highlight' : 'Write'
  } 4 words or more to unlock AI magic 🪄`;
};

/**
 *
 */
const getWordsLenghtMessage = (highlighted: boolean) => {
  return `Please ${
    highlighted ? 'select' : 'write'
  } less than 10K characters to unlock AI magic 🪄`;
};

/**
 *
 */
const getPromptAnnotation = (service: string) => {
  const destination =
    service === SERVICE_STARTPAGE ? 'a short blog post' : service;

  let annotation = `Write the result with a format that is valid for ${destination},
    in plain text, without any links or hashtags.`;

  const serviceConfig = Services.get(service);
  const charLimit = serviceConfig ? serviceConfig.charLimit : null;
  annotation = annotation.concat(
    charLimit ? `And limit the result to ${charLimit} characters.` : ''
  );

  return annotation;
};

export {
  hasMinWords,
  hasRightLength,
  getButtonClassNames,
  getRequirementsMessage,
  getWordsLenghtMessage,
  getPromptAnnotation,
};
